import { Redirect } from "react-router-dom";

/** Preserves query string and hash when /v2 bookmarks redirect to /. */
const V2Redirect = ({ location }) => (
  <Redirect
    to={{ pathname: "/", search: location.search, hash: location.hash }}
  />
);

export default V2Redirect;
